import { hideBanner, showBanner } from '@ths/shared/store/slices/banner';
import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../store/store';
import { THS_PHONE_NUMBER } from '../utilities/getContactEmailByPod';

/**
 * Custom hook that automatically shows/hides a global banner
 * when the client account is inactive.
 *
 * Banner displays customer support contact information and is non-dismissible.
 *
 * Usage: Call this hook in Wrapper or App component to enable
 * global inactive client warnings.
 */
export const useInactiveClientBanner = () => {
  const dispatch = useAppDispatch();
  const client = useAppSelector((state) => state.user.profile?.client);

  useEffect(() => {
    if (client?.isInactive) {
      dispatch(
        showBanner({
          message: `Your account is currently inactive. Please contact customer support at ${THS_PHONE_NUMBER}.`,
          type: 'warning',
          dismissible: false,
        }),
      );
    } else {
      dispatch(hideBanner());
    }
  }, [client, dispatch]);
};
